import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mt-8 bg-gray-300 p-2" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Etherscan: ")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<p> GitHub: <a href=\"https://github.com/Cryptocoders-wtf/generative\" class=\"underline\" target=\"_blank\">WebUI &amp; Contract</a></p><p> Project Vision: <a href=\"https://hackmd.io/@snakajima/HJva6n-Jj\" class=\"underline\" target=\"_blank\">On-line Asset Store and Composer</a></p><p> Discord: <a href=\"https://discord.gg/4JGURQujXK\" class=\"underline\" target=\"_blank\">On-chain Asset Store</a></p><p> Twitter: <a href=\"https://twitter.com/nounsfes\" class=\"underline\" target=\"_blank\">@nounsfes (English)</a>, <a href=\"https://twitter.com/snakajima\" class=\"underline\" target=\"_blank\">@snakajima (Japanese)</a></p>", 4)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("message.resources")), 1)
    ]),
    (_ctx.EtherscanToken)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
          _hoisted_5,
          (_ctx.TokenName)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                _createElementVNode("a", {
                  href: _ctx.EtherscanToken,
                  class: "underline",
                  target: "_blank"
                }, _toDisplayString(_ctx.TokenName), 9, _hoisted_7)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _hoisted_8
  ]))
}